import { useQuery } from "@apollo/client";
import { useEffect } from "react";

import { GridInputs } from "../../../../../components/Functional";
import { FETCH_ARTISTS as fetchArtists } from "../../../../../graphql/query/Artist";
import { FETCH_WAREHOUSE_CATEGORIES } from "../../../../../graphql/query/WarehouseCategory";
import { FETCH_WAREHOUSE_SITES } from "../../../../../graphql/query/WarehouseSite";
import { useEntities } from "../../../../../hooks/useEntities";

const Items = props => {
  const { formik } = props || {};
  const { data: { artists } = {} } = useQuery(fetchArtists());
  const { entities } = useEntities();
  const { data: { warehouseCategories = [] } = {} } = useQuery(
    FETCH_WAREHOUSE_CATEGORIES,
  );
  const { data: { warehouseSites = [] } = {} } = useQuery(
    FETCH_WAREHOUSE_SITES,
  );

  useEffect(() => {
    if (formik?.values?._unlocated) {
      formik.setFieldValue("_warehouseMove.locationId", {
        value: null,
        operator: "isNull",
      });
    } else {
      formik.setFieldValue("_warehouseMove.locationId", null);
    }
  }, [formik?.values?._unlocated]);

  const inputs = {
    className: "mt-5 grid grid-cols-1 gap-4 lg:grid-cols-4 lg:gap-16",
    inputs: [
      {
        className: "grid-cols-1 gap-4",
        inputs: [
          {
            label: "Item #",
            name: "_warehouseMove._warehouseItem.id",
            type: "number",
          },
          {
            label: "Warehouse Item Category",
            name: "_warehouseMove._warehouseItem.categoryId",
            type: "multi-select",
            isMulti: true,
            options: warehouseCategories.map(category => ({
              label: category.description,
              value: category.id,
            })),
          },
        ],
      },
      {
        className: "grid-cols-1 gap-4",
        inputs: [
          {
            label: "User",
            name: "_warehouseMove.user",
            type: "multi-select",
            options:
              entities?.edges?.map(item => ({
                label: item.name,
                value: item.name,
              })) || [],
          },
          {
            label: "Site",
            name: "_warehouseMove.siteId",
            type: "multi-select",
            isNullable: true,
            options: warehouseSites.map(site => ({
              label: site.name,
              value: site.id,
            })),
          },
        ],
      },
      {
        className: "grid-cols-1 gap-4",
        inputs: [
          {
            label: "Artist",
            name: "_warehouseMove._warehouseItem.artistId",
            type: "multi-select",
            options: artists?.map(artist => ({
              label: artist?.name,
              value: artist?.id,
            })),
          },
        ],
      },
      {
        className: "grid-cols-1 gap-4",
        inputs: [
          {
            label: "Unlocated",
            name: "_unlocated",
            type: "toggle",
            designType: "checkbox",
          },
          {
            label: "Customs Controlled",
            name: "_warehouseMove.ti",
            type: "toggle",
            designType: "threeStateCheckbox",
          },
        ],
      },
    ],
  };

  const gridInputProps = {
    formik,
    ...inputs,
  };

  return (
    <div className="pb-4">
      <GridInputs {...gridInputProps} />
    </div>
  );
};

export default Items;
